<template>
  <div>
    <h3>{{name}}</h3>

    <div class="row" v-if="canEdit">
      <div class="col-6">
        <under-input v-model="item.name">Name</under-input>
      </div>
      <div class="col">
        <under-select v-model="item.type" :options="itemTypes">Type</under-select>
      </div>
      <div class="col">
        <under-select
          v-model="item.weight"
          :options="bulkOptions"
          v-if="['PF Playtest', 'PFRPG2', 'Embers RPG'].includes(ruleset) && item"
        >Bulk</under-select>
        <under-input v-model.number="item.weight" type="number" v-else>Weight (lbs)</under-input>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <under-input v-model="item.detail">( Detail )</under-input>
      </div>
      <div class="col">
        <under-input v-model.number="item.quantity" type="number">Quantity</under-input>
      </div>
      <div class="col text-center">
        <under-checkbox v-model="item.carried">Carried</under-checkbox>
      </div>
      <div class="col text-center">
        <under-checkbox v-model="item.equipped">Equipped</under-checkbox>
      </div>
    </div>
    <under-input v-if="canEdit" v-model="item.summary" maxlength="255">Summary</under-input>
    <under-text-area-md v-if="canEdit" v-model="item.description" rows="6">Description</under-text-area-md>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import UnderCheckbox from "../shared/_UnderCheckbox.vue";
import UnderInput from "../shared/_UnderInput.vue";
import UnderSelect from "../shared/_UnderSelect.vue";
import UnderSelect2 from "../shared/_UnderSelect2.vue";
import UnderTextAreaMd from "../shared/_UnderTextAreaMd.vue";

export default {
  name: "sections-items-default",
  components: {
    UnderCheckbox,
    UnderInput,
    UnderSelect,
    UnderSelect2,
    UnderTextAreaMd,
  },
  props: ["section", "item"],
  watch: {
    "item.equipped": "setCarried",
    "item.carried": "setEquipped",
  },
  computed: {
    ...mapState({
      ruleset: (state) => state.characters.current.ruleset,
    }),
    ...mapGetters({
      charactersCanEdit: "characters/canEdit",
    }),
    name() {
      return this.canEdit ? "Item" : this.item.name;
    },
    canEdit() {
      return this.charactersCanEdit && this.item.stock !== true;
    },
    itemTypes() {
      let options = [];
      let itemTypes = this.$rulesets[this.ruleset].getItemTypes();

      itemTypes.forEach((element) => {
        options.push({ text: element, value: element });
      });
      return options;
    },
    bulkOptions() {
      let resultArray = this.$rulesets[this.ruleset]
        .getBulkOptions()
        .map((elm) => {
          return { text: elm.text, value: elm.id };
        });

      return resultArray;
    },
  },
  methods: {
    setEquipped() {
      if (!this.item.carried) this.item.equipped = false;
    },
    setCarried() {
      if (this.item.equipped) this.item.carried = true;
    },
  },
};
</script>
